import React, { useContext, useState } from 'react'

import type { CollectionFilters } from 'modules/attendance/components/TimeTrackingCollection/lib/transformFilters'

interface TimeTrackingDataContextType {
  selectAll: boolean
  selectedEmployeeIds: number[]
  excludedEmployeeIds: number[]
  filters: CollectionFilters | null
  search: string | undefined
  selectedEmployeeCount: number
  totalEmployeeCount: number
  setSelectAll: (value: boolean) => void
  setSelectedEmployeeIds: (value: number[]) => void
  setExcludedEmployeeIds: (value: number[]) => void
  setFilters: (value: CollectionFilters | null) => void
  setSearch: (value: string | undefined) => void
  setSelectedEmployeeCount: (value: number) => void
  setTotalEmployeeCount: (value: number) => void
}

const Context = React.createContext<TimeTrackingDataContextType | undefined | null>(null)

export const TimeTrackingDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectAll, setSelectAll] = useState<boolean>(false)
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState<number[]>([])
  const [excludedEmployeeIds, setExcludedEmployeeIds] = useState<number[]>([])
  const [filters, setFilters] = useState<CollectionFilters | null>(null)
  const [search, setSearch] = useState<string | undefined>(undefined)
  const [selectedEmployeeCount, setSelectedEmployeeCount] = useState<number>(0)
  const [totalEmployeeCount, setTotalEmployeeCount] = useState<number>(0)

  return (
    <Context.Provider
      value={{
        selectAll,
        selectedEmployeeIds,
        excludedEmployeeIds,
        filters,
        search,
        selectedEmployeeCount,
        totalEmployeeCount,
        setSelectAll,
        setSelectedEmployeeIds,
        setExcludedEmployeeIds,
        setFilters,
        setSearch,
        setSelectedEmployeeCount,
        setTotalEmployeeCount,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useTimeTrackingData = (): TimeTrackingDataContextType => {
  const context = useContext(Context)
  if (!context) {
    throw new Error('useTimeTrackingData must be used within a TimeTrackingDataProvider')
  }
  return context
}
